/**
 * Site config barrel — re-exports the active deployment's configuration.
 *
 * Set REACT_APP_SITE=nyc or REACT_APP_SITE=sb in your environment
 * (or use the npm scripts: start:nyc / start:sb / build:nyc / build:sb).
 * Defaults to 'nyc' when unset.
 */

import { siteConfig as nycConfig } from './siteConfig.nyc';
import { siteConfig as sbConfig } from './siteConfig.sb';

const site = process.env.REACT_APP_SITE || 'nyc';

export const siteConfig = site === 'sb' ? sbConfig : nycConfig;
